import { getRouteTitle } from '../selectors';

import { composeSubscriber } from '../module';

export const updateWindowTitle = composeSubscriber({
  selector: getRouteTitle,
  onChange: title => {
    if (!document) {
      // don't warn in Node environment
      return;
    }

    if (!title || document.title === title) {
      return;
    }

    document.title = title;
  }
});
